// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"city-5"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M16 21V10C13.9493 12.5633 10.0507 12.5633 8 10V21H12H16Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M3 21H8V5L5.5 3L3 5V21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M21 21V5L18.5 3L16 5V21H21Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 21V16","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M16 21H21V5L18.5 3L16 5V21ZM16 21H8M8 21H3V5L5.5 3L8 5V21ZM8.5 10.5419C10.4585 12.3827 13.5415 12.3827 15.5 10.5419","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-city-5')
export default class City5Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-5',
    }
  }
}
